import { BIM360Project } from './BIM360Project';

export abstract class BIM360Hub
{
    public id: string = '';
    public name: string = '';
    public url: string = '';
    public type: string = '';
    public region: string = '';

    public abstract getProjects(): Promise<BIM360Project[]>;
}
